import React from 'react';

import Card, { Flag } from './DashboardCard';
import MovementWidget from './MovementWidget';
import RadioTileStrip from './RadioTileStrip';

// IB-677 rework — the single consistent per-type dashboard skeleton, learned once
// and repeated on every type tab: KPI strip → the compact three-widget row (profile
// donut · movement · type-specific key metric) → focus table. Risks additionally
// passes `extra` (Risks by type), which turns the bottom into a two-up row.
//
// props:
//   tiles     — RadioTileStrip tiles
//   profile   — { title, content }        (the donut)
//   movement  — { data, category }        (wrapped in the "Movement this period" card)
//   keyMetric — { title, flag?, content } (the type-specific bars)
//   focus     — a FocusTable node (renders its own card)
//   extra     — { title, flag?, content } (optional; Risks only → two-up bottom)
export default function RadioDashboardSkeleton({ tiles, profile, movement, keyMetric, focus, extra }) {
    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <RadioTileStrip tiles={tiles} />

            <div className="tw-grid tw-grid-cols-1 tw-gap-3 lg:tw-grid-cols-3">
                <Card title={profile.title} minHeight={170}>
                    {profile.content}
                </Card>
                <Card title={$t('Movement this period')} flag={<Flag tone="new">{$t('new')}</Flag>} minHeight={170}>
                    <MovementWidget movement={movement.data} category={movement.category} />
                </Card>
                <Card title={keyMetric.title} flag={keyMetric.flag} minHeight={170}>
                    {keyMetric.content}
                </Card>
            </div>

            {extra ? (
                <div className="tw-grid tw-grid-cols-1 tw-gap-3 lg:tw-grid-cols-2">
                    {focus}
                    <Card title={extra.title} flag={extra.flag}>
                        {extra.content}
                    </Card>
                </div>
            ) : (
                focus
            )}
        </div>
    );
}
